var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modalRespon",
    attrs: {
      "id": "modal-respon",
      "title": "Respon PPFTZ",
      "variant": "success",
      "hide-footer": "",
      "no-close-on-esc": ""
    }
  }, [_c('loading', {
    attrs: {
      "active": this.$store.state.barpin.isLoadingModal,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        this.$store.state.barpin.isLoadingModal = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-responsive"
  }, [(_vm.$store.state.barpin.respon.status > '100') ? _c('tr', [_c('td', [_vm._v("Respon Penerimaan")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.$http.options.root + '/ppftz/pdf/penerimaan/' + _vm.$store.state.barpin.respon.id
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.respon.status > '100') ? _c('tr', [_c('td', [_vm._v("PPFTZ")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.$http.options.root + '/ppftz/pdf/ppftz/' + _vm.$store.state.barpin.respon.id
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.respon.status > '110' && this.$store.state.barpin.files.file_billing) ? _c('tr', [_c('td', [_vm._v("Kode Billing")]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_billing) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$store.state.barpin.header.no_aju) + "/" + (this.$store.state.barpin.files.file_billing))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.respon.status > '116') ? _c('tr', [_c('td', [_vm._v("SURAT PEMERIKSAAN FISIK (SPF)")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.$http.options.root + '/ppftz/pdf/spf/' + _vm.$store.state.barpin.respon.id
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.respon.status > '116') ? _c('tr', [_c('td', [_vm._v("Instruksi Pemeriksaan (IP)")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.$http.options.root + '/ppftz/pdf/ip/' + _vm.$store.state.barpin.respon.id
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.respon.status >= '150') ? _c('tr', [_c('td', [_vm._v("SPPB")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.$http.options.root + '/ppftz/pdf/sppb/' + _vm.$store.state.barpin.respon.id
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.respon.status == '145') ? _c('tr', [_c('td', [_vm._v("NOTA PENOLAKAN")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.$http.options.root + '/ppftz/pdf/nolak/' + _vm.$store.state.barpin.respon.id
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1)])]) : _vm._e()])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da117304","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ppftz/modal/ModalRespon.vue
// module id = 376
// module chunks = 0